import React from 'react'
import { FootNote, ReportBodyScroll, ReportCard, STALE_FIGURES_CLASS } from './interactive.styled'
import { ReportTableFrame } from './ReportTableFrame'
import { ReportTitleHeader } from './ReportTitleHeader'

type Props = {
  title?: React.ReactNode
  isRefreshing?: boolean
  isStale?: boolean
  banner?: React.ReactNode
  footNote: React.ReactNode
  tableMinWidth: number
  children: React.ReactNode
}

export const ReportCardLayout: React.FC<Props> = ({
  title,
  isRefreshing = false,
  isStale = false,
  banner,
  footNote,
  tableMinWidth,
  children
}) => (
  <ReportCard>
    {title != null ? (
      <ReportTitleHeader title={title} isRefreshing={isRefreshing && !isStale} />
    ) : null}
    {banner}
    <ReportBodyScroll className={isStale ? STALE_FIGURES_CLASS : undefined}>
      <ReportTableFrame minWidth={tableMinWidth}>{children}</ReportTableFrame>
    </ReportBodyScroll>
    <FootNote>{footNote}</FootNote>
  </ReportCard>
)
